// TYPES
// COMPONENTS
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
// i18N
import { getText } from 'i18n/intl';
// ACTIONS
import {
  MAINTENANCE_CLEAR_CACHE_ID,
  fetchMaintenance,
  maintenanceSelector,
} from 'slices/maintenance.slice';
import { useAppDispatch } from 'slices/store';
import {
  fetchSystemActions,
  systemActionsSelector,
} from 'slices/systemActions.slice';
import type { TSystemAction } from '@timeedit/types/lib/types/systemAction.type';
import { DefaultContentLayout } from '@timeedit/ui-components';
import { Maintenance } from './MaintenanceComponent';
import { MaintenanceMiscellaneous } from './MaintenanceMiscellaneous';
import './index.scss';

const ObjectTypes = () => {
  const dispatch = useAppDispatch();
  const maintenance = useSelector(maintenanceSelector);
  const systemActions: TSystemAction[] = useSelector(systemActionsSelector);

  useEffect(() => {
    dispatch(fetchMaintenance());
    dispatch(fetchSystemActions());
  }, []);

  const maintenanceOps = useMemo(() => {
    return [
      {
        description: 'This will clear the cache for integration service.',
        id: MAINTENANCE_CLEAR_CACHE_ID,
        name: 'Clear integration cache',
      },
      ...maintenance,
    ];
  }, [maintenance]);

  return (
    <DefaultContentLayout
      title={getText('maintenance')}
      subtitle={getText('maintenance_management')}
    >
      <Maintenance maintenance={maintenanceOps} />
      <MaintenanceMiscellaneous systemActions={systemActions} />
    </DefaultContentLayout>
  );
};

export default ObjectTypes;
